<template>
  <div id="membership-container">
    <!-- <DELETE CONFIRM DIALOG> -->
    <v-dialog v-model="deleteConfirmDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Da li ste sigurni da želiti izbrisati članarinu?</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" flat="flat" @click="deleteConfirmDialog = false">Prekini</v-btn>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="deletePayment"
          >Izbriši</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <DELETE CONFIRM DIALOG> -->
    <!-- <PAYMENT CREATE DIALOG> -->
    <v-dialog v-model="paymentCreateDialog" max-width="590">
      <v-card>
        <v-card-text>
          <payment-create
            @closeDialog="paymentCreateDialog = false"
            @refreshData="getAllPayments"
            :years="years"
            :months="months"
          ></payment-create>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- </PAYMENT CREATE DIALOG> -->
    <div
      class="clear-filter"
      v-if="clearFilteredData"
      @click="resetData"
    >Očisti filtrirane rezultate</div>

    <!-- <FILTER DIALOG> -->
    <v-dialog v-model="filterDialog" max-width="790">
      <filter-payments
        :years="years"
        :months="months"
        @closeDialog="filterDialog = false"
        @filterPayments="filterPayments"
        @resetSelectedPage="resetSelectedPage"
        :filterType="selectedFilter"
      ></filter-payments>
    </v-dialog>
    <!-- </FILTER DIALOG> -->
    <div id="header" class="text-right">
      <h1 class="header-text" style="float:left;">
        <span>Evidencija uplata
          <div class="header-text-line"></div>
        </span>
      </h1>
      <img
        @click="paymentCreateDialog = true"
        class="action-icon-lg"
        src="../../assets/icons/create.png"
        alt="Create user"
      >
      <!-- <FILTER> -->
      <v-menu open-on-hover bottom offset-y style="float:right;">
        <img
          slot="activator"
          class="action-icon-lg"
          src="../../assets/icons/filter.png"
          alt="Filter user"
        >
        <v-list>
          <v-list-tile
            v-for="(item, index) in filterSelector"
            :key="index"
            @click="openFilterDialog(item.value)"
          >
            <v-list-tile-title>
              <span>{{ item.text }}</span>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <!-- </FILTER> -->
    </div>

    <!-- <PAYMENT DATA LIST> -->
    <v-container>
      <v-data-table :headers="headers" :items="payments" hide-actions class="elevation-1">
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.Year }}</td>
          <td class="text-xs-left">{{ getMonthNameByIndex(props.item.Month) }}</td>
          <td class="text-xs-left">{{ props.item.Quantity }}</td>
          <td class="text-xs-left">
            <img :src="props.item.User.ProfileUrl" class="small-profile">
            {{ props.item.User.Name }}
          </td>
           <td class="text-xs-center">
            <img
              @click="setMfToDelete(props.item.MembershipFeeId)"
              src="../../assets/icons/delete.png"
              class="action-icon-sm"
              alt="Uredi"
            >
          </td>
        </template>
      </v-data-table>
    </v-container>
    <!-- </PAYMENT DATA LIST> -->
    <!-- <PAGINATION> -->
    <div class="text-xs-center pagination">
      <v-pagination :total-visible="5" @input="getPayments" v-model="selectedPage" :length="numberOfPages"></v-pagination>
    </div>
    <!-- </PAGINATION> -->
  </div>
</template>

<script>
import PaymentCreate from "./Create";
import MembershipFeeFilter from "./Filter";
export default {
  components: {
    paymentCreate: PaymentCreate,
    filterPayments: MembershipFeeFilter
  },
  data() {
    return {
      payments: [],
      paymentCreateDialog: false,
      years: [],
      months: [
        {
          Name: "Januar",
          Id: 1
        },
        {
          Name: "Februar",
          Id: 2
        },
        {
          Name: "Mart",
          Id: 3
        },
        {
          Name: "April",
          Id: 4
        },
        {
          Name: "May",
          Id: 5
        },
        {
          Name: "May",
          Id: 5
        },
        {
          Name: "Juni",
          Id: 6
        },
        {
          Name: "Juli",
          Id: 7
        },
        {
          Name: "August",
          Id: 8
        },
        {
          Name: "Septembar",
          Id: 9
        },
        {
          Name: "Oktobar",
          Id: 10
        },
        {
          Name: "Novembar",
          Id: 11
        },
        {
          Name: "Decembar",
          Id: 12
        }
      ],
      //Data list
      headers: [
        {
          text: "Godina",
          value: "godina",
          align: "left"
        },
        {
          text: "Mjesec",
          value: "mjesec",
          align: "left"
        },
        {
          text: "Uplatio/la",
          value: "uplata",
          align: "left"
        },
        {
          text: "Korisnik",
          value: "korisnik",
          align: "left"
        },
        {
          text: "Akcije",
          value: "korisnik",
          align: "center"
        }
      ],
      //Pagination
      numberOfPages: 1,
      selectedPage: 1,
      //Filter selector
      filterSelector: [
        {
          text: "Godina i mjesec",
          value: "date"
        },
        {
          text: "Korisnik",
          value: "studio"
        }
      ],
      filterDialog: false,
      selectedFilter: null,
      clearFilteredData: false,
      filterObject: null,
      deleteConfirmDialog: false,
      mfToDelete: null,
    };
  },
  methods: {
    getPayments() {
      if (this.selectedFilter == null) {
        this.getAllPayments();
      } else {
        this.filterPayments();
      }
    },
    getAllPayments() {
      this.$store.state.services.membershipFeeService
        .getByIndex(this.selectedPage)
        .then(response => {
          this.payments = response.data.Payments;
          this.numberOfPages = response.data.NumberOfPages;
        });
    },
    filterByYearAndMonth() {
      this.$store.state.services.membershipFeeService
        .filterByYearAndMonth(
          this.selectedPage,
          this.filterObject.Year,
          this.filterObject.Month
        )
        .then(response => {
          this.payments = response.data.Payments;
          this.numberOfPages = response.data.NumberOfPages;
        });
    },
    filterByUser() {
      this.$store.state.services.membershipFeeService
        .filterByUser(this.selectedPage, this.filterObject.UserId)
        .then(response => {
          this.payments = response.data.Payments;
          this.numberOfPages = response.data.NumberOfPages;
        });
    },
    filterPayments(filter) {
      if (filter != undefined) {
        this.filterObject = filter;
      }
      this.clearFilteredData = true;
      this.filterDialog = false;
      if (this.selectedFilter == "date") {
        this.filterByYearAndMonth();
      } else {
        this.filterByUser();
      }
    },
    getMonthNameByIndex(index) {
      return this.months.find(el => el.Id == index).Name;
    },
    fillYears() {
      var today = new Date();
      var currentYear = today.getFullYear();
      var i = currentYear - 2;
      for (i; i < currentYear + 10; i++) {
        this.years.push(i);
      }
    },
    openFilterDialog(filterType) {
      this.filterDialog = true;
      this.selectedFilter = filterType;
    },
    resetSelectedPage() {
      this.selectedPage = 1;
    },
    resetData() {
      this.clearFilteredData = false;
      this.selectedFilter = null;
      this.getAllPayments();
    },
    setMfToDelete(mfId){
      this.deleteConfirmDialog = true;
      this.mfToDelete = mfId;
    },
    deletePayment(mfId){
      this.deleteConfirmDialog = false;
      this.$store.state.services.membershipFeeService
      .remove(this.mfToDelete)
      .then(res => {
        this.getPayments();
        this.$store.dispatch("setResponseMessage", res.data);
      })
    }
  },
  created() {
    this.getAllPayments();
    this.fillYears();
  }
};
</script>

<style scoped>
#membership-container {
  padding-bottom: 40px;
}
.small-profile {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}
@media(max-width: 768px) {
  .small-profile{
    display: none;
  }
}
</style>
